import React, { Component } from 'react';
import { connect } from 'react-redux';
import { countdownSet } from '~/store/actions/countdown';
import PropTypes from 'prop-types';
import { translate } from '~/decorators';
import Value from '~/views/Home/base/Value';
import oget from 'oget';
import moment from 'moment-timezone';
import CurrentScoresScored from './CurrentScoresScored';
import CurrentScoresTimed from './CurrentScoresTimed';
import './index.scss';

export default
@translate(
    'home.header.header-scores'
)
@connect(
    null,
    dispatch => ({
        onCountdownSet: (...args) => dispatch(
            countdownSet(...args)
        )
    })
)
class HeaderScores extends Component {
    static propTypes = {
        deviceType: PropTypes.any.isRequired,
        round: PropTypes.oneOfType([
            item => item === null,
            PropTypes.object.isRequired
        ]),
        athletes: PropTypes.shape({
            expectedHeatId: PropTypes.any,
            byId: PropTypes.object,
            isLiveId: PropTypes.any
        }).isRequired,
        countdown: PropTypes.shape({
            lastUpdated: PropTypes.any,
            timeLeft: PropTypes.any
        }).isRequired,
    }

    tickInterval;

    componentDidMount() {
        this.tickInterval = setInterval(() => {
            const {
                countdown: { timeLeft },
                onCountdownSet
            } = this.props;

            if (timeLeft !== null) {
                onCountdownSet(timeLeft - 1000);
            }
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.tickInterval);
    }

    render() {
        const {
            t,
            locale,
            athletes,
            deviceType,
            countdown: { timeLeft },
            colors,
            round
        } = this.props;

        if (!athletes.isLiveId) {
            return (
                <div className="header-scores not-available">
                    {t('No live information at this time')}
                </div>
            );
        }

        moment.locale(
            locale.substr(0, 2)
        );

        const athleteLive = athletes.byId[
            athletes.isLiveId
        ];

        const current = oget(
            athleteLive,
            'details.Current',
            {}
        );

        const needs = oget(
            athleteLive,
            'details.Needs.values',
            []
        );

        const needsLabel = oget(
            athleteLive,
            'details.Needs.label',
            'Needs'
        );

        const timeLeftParsed = moment.duration(
            timeLeft,
            'ms'
        );

        const roundType = oget(
            round,
            'type'
        );

        const isScored = roundType !== 'Time';

        return (
            <div className="header-scores">
                <div className={
                    `top-scores ${
                        isScored
                            ? 'scored'
                            : 'timed'
                    }`
                }>

                    <div className="left-scores">
                        <div className="summary">
                            <div className="rank">
                                <span className="label">
                                    {t('Rank')}
                                </span>

                                {' '}

                                <span className="text">
                                    {athleteLive.rank !== undefined
                                    && athleteLive.rank !== null
                                    && (
                                        <Value>
                                            {athleteLive.rank}
                                        </Value>
                                    )}
                                </span>
                            </div>

                            <div className="total">
                                <span className="label">
                                    {isScored
                                        ? t('Total')
                                        : t('Time')
                                    }
                                </span>

                                {' '}

                                <span className="text">
                                    <Value>{athleteLive.value}</Value>
                                </span>
                            </div>

                            {!!needs.length &&
                                <div className={`needs ${
                                    needs.length > 1
                                        ? 'two'
                                        : ''
                                    }`}
                                >
                                    <span className="label">
                                        {t(needsLabel)}
                                    </span>

                                    {' '}

                                    <span className="text">
                                        <div>
                                            <Value>{needs[0].points}</Value>
                                            {' '}|{' '}
                                            {t(needs[0].rank)}
                                        </div>

                                        {needs.length > 1 &&
                                            <div>
                                                <Value>{needs[1].points}</Value>
                                                {' '}|{' '}
                                                {t(needs[1].rank)}
                                            </div>
                                        }
                                    </span>
                                </div>
                            }

                            <div className="time text">
                                {timeLeft !== null &&
                                    <span>
                                        {`${timeLeftParsed.minutes()}`.padStart(2, '0')}
                                        :{`${timeLeftParsed.seconds()}`.padStart(2, '0')}
                                    </span>
                                }
                            </div>
                        </div>

                        {isScored &&
                            <CurrentScoresScored
                                athleteLive={athleteLive}
                                t={t}
                                colors={colors}
                            />
                        }
                    </div>

                    {!isScored &&
                        <div className="right-scores">
                            <CurrentScoresTimed
                                deviceType={deviceType}
                                athleteLive={athleteLive}
                                t={t}
                                colors={colors}
                            />
                        </div>
                    }


                        <div className="right-scores">
                            <div className="current-rank">
                                {isScored && isFinite(current.rank) && [
                                    <div
                                        key="header-scores-current-attempt-label"
                                        className="label-container"
                                    >
                                        <span className="label">
                                            {t('Current Attempt')}
                                        </span>
                                    </div>,

                                    <div
                                        key="header-scores-current-attempt-value"
                                        className="data"
                                    >
                                        <div
                                            className="current-attempt"
                                            style={colors.headerScores.scoreBoxCurrent}
                                        >
                                            <Value>{current.rank}</Value>
                                        </div>
                                    </div>
                                ]}
                            </div>

                            {/* <div>
                                <span className="label-container">
                                    <span className="label">{t('Trick')}:</span>
                                </span>

                                <span className="text">
                                    Name of the Trick that{' '}
                                    can be really very long
                                </span>
                            </div>

                            <div>
                                <span className="label-container">
                                    <span className="label">{t('Improves By')}</span>
                                </span>

                                <span className="text">0.9</span>
                            </div> */}
                        </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/header/HeaderScores/index.js